import React from "react"
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap"

const TransferModal = ({
  isOpen,
  toggle,
  transferInfo,
  loading,
  onProceed,
}) => {
  if (!transferInfo) return null

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle}>
        Re-allocation Request -{" "}
        {transferInfo?.item?.ip_item_description ||
          transferInfo?.item?.name ||
          ""}
      </ModalHeader>
      <ModalBody>
        <div className="mb-4">
          <div className="row">
            <div className="col-md-4 mb-3">
              <div className="p-3 border rounded text-center bg-light">
                <small className="text-muted d-block">Total Receipt</small>
                <strong className="fs-5">
                  {transferInfo.total_receipt_qty}
                </strong>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="p-3 border rounded text-center bg-light">
                <small className="text-muted d-block">Used / Distributed</small>
                <strong className="fs-5">{transferInfo.used_qty}</strong>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="p-3 border rounded text-center bg-success bg-opacity-10">
                <small className="text-muted d-block">
                  Available (to Transfer)
                </small>
                <strong className="fs-5 text-success">
                  {transferInfo.available_qty}
                </strong>
              </div>
            </div>
          </div>
          <div className="mb-3">
            <small className="text-muted">
              Batch: <strong>{transferInfo.batch_number}</strong> | Expire:{" "}
              <strong>{transferInfo.expire_date}</strong>
            </small>
          </div>
        </div>
        <p className="text-muted mb-0">
          The entire available quantity of{" "}
          <strong>{transferInfo.available_qty}</strong> will be transferred back
          to the source provider.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={() => onProceed(transferInfo.available_qty)}
          disabled={loading}
        >
          {loading ? <Spinner size="sm" className="me-1" /> : null}
          Proceed
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default TransferModal
